import { Component, Input, OnInit } from '@angular/core';
import { CreateUser, createuserdefaultvalues } from '../users/createuser';
import { TranslationService } from 'src/app/services/translation.service';

@Component({
    selector: 'app-registration-form',
    templateUrl: './registration-form.component.html',
    styleUrls: ['./registration-form.component.scss'],
    standalone: false
})
export class RegistrationFormComponent implements OnInit {

  @Input() createuserobj:CreateUser=createuserdefaultvalues();
  @Input() isSubmitted=true

  termsAndConditionsCheck:boolean=false;
  statementCheck:boolean=false;
  confirmPassword:string='';
  revealNewPassword: boolean = false;
  revealConfirmPassword: boolean = false;
  translations: Record<string, string> = {};

  constructor(private translationService: TranslationService) {}

  ngOnInit(): void {
    this.translationService.getTranslation().subscribe({
      next: (translations) => {
        this.translations = translations;
      }
    });
  }

  checkPasswordRequirements():boolean
  {
    const hasUpperCase = /[A-Z]/.test(this.createuserobj.password);
    const hasLowerCase = /[a-z]/.test(this.createuserobj.password);
    const hasSpecialCharacter = /[!@#$%^&*(),.?":{}|<>]/.test(this.createuserobj.password);
    const hasMinLength = this.createuserobj.password.length >= 10;

    const passwordValid = hasUpperCase && hasLowerCase && hasSpecialCharacter && hasMinLength;

    if (!passwordValid) {
      return false;
    }
    return true;
  }

  validateRequiredFields():boolean
  {
    let flag=true
    if(this.createuserobj.displayName=='' || this.createuserobj.displayName==null)
    {
      flag=false
    }
  
    if(this.createuserobj.userName==''||this.createuserobj.userName==null)
    {
      flag=false  
    }
    if(this.createuserobj.age==0||this.createuserobj.age==null)
    {
      flag=false
    }
    if(this.createuserobj.password == ''||this.createuserobj.password==null)
    {
      flag=false
    }
    if(this.confirmPassword == ''||this.confirmPassword==null||this.confirmPassword != this.createuserobj.password)
    {
      flag=false
    }
    if(!this.checkPasswordRequirements())
    {
      flag=false
    }
    if(!this.termsAndConditionsCheck)
    {
      flag=false
    }
    if(!this.statementCheck)
    {
      flag=false
    }
    return flag;
  }

 
}
